import { getMessages } from '../../../../../../../store/constants';

export const CARD_CHECKLIST_ADD_BUTTON = getMessages().getText('card_form_checklist_add_new_item');
export const CARD_CHECKLIST_ADD_PLACEHOLDER = getMessages().getText('card_form_checklist_add_placeholder');
export const CARD_CHECKLIST_ADD_MOBILE_BUTTON = getMessages().getText('card_form_checklist_add');

export const CHECKLIST_WEIGHT_DEFAULT = 1;
